<template>
	<div class='fancy_input' v-bind:style='{width: width || "auto"}'>
		<div 
			style='position: relative; display: inline-block;'
		>
			<div
				class='fancy_input__placeholder'
				:class='{
					"fancy_input__placeholder--active": active || value.length,
					"fancy_input__placeholder--large": large
				}'
			>
				{{placeholder}}
			</div>
			<input
				v-bind:type='type || "text"'
				class='fancy_input__input input'
				:class='{
					"fancy_input__input--large": large,
					"fancy_input__input--error": error
				}'
				v-bind:value='value'
				v-on:input='updateValue($event.target.value)'
				@focus='addActive'
				@blur='removeActive'
			>
		</div>
		<error-tooltip :error='error'></error-tooltip>
	</div>
</template>

<script>
	import ErrorTooltip from './ErrorTooltip'

	export default {
		name: 'FancyInput',
		props: ['value', 'placeholder', 'width', 'type', 'error', 'large'],
		components: {
			ErrorTooltip
		},
		data () {
			return {
				active: false
			}
		},
		methods: {
			updateValue (val) {
				this.$emit('input', val);
			},
			addActive () {
				this.active = true;
			},
			removeActive () {
				this.active = false;
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/scss/variables.scss';

	.fancy_input {

		@at-root #{&}__input {
			transition: border-color 0.2s;
			width: 100%;
			display: block;
			height: calc(2.25em + 0.75rem + 2px);
			padding: 0.375rem 0.75rem;
			font-size: 1rem;
			font-weight: 500;
			line-height: 2.25;
			color: #fff;
			background-color: #13181d;
			background-clip: padding-box;
			border: 1px solid #00ff7f;
			border-radius: 0;

			@at-root #{&}--large {
				padding: 1rem 0.5rem;
				background: transparent;
				color: #fff;
				height: 51px;
			}
			@at-root #{&}--error {
				border-color: $color__red--primary;
			}
		}

		@at-root #{&}__placeholder {
			position: absolute;
			left: 1.35rem;
			top: 0.8rem;
			color: #fff;
			pointer-events: none;
			transition: top 0.2s, font-size 0.2s;

			@at-root #{&}--large {
				left: 0.6rem;
				top: 0.8rem;
			}

			@at-root #{&}--active {
				top: 0;
				font-size: 0.75rem;
				transition: top 0.2s, font-size 0.2s;
			}
		}
	}
</style>